import { Component } from '@angular/core';
import { ProductFavoriteIconComponent } from 'projects/shared/lib/components/shared/product/favorite-icon/product-favorite-icon.component';
import { EFavoriteType } from 'projects/shared/lib/services/INTEGRA_Shop_Client';

@Component({
    selector: 'app-product-favorite-icon',
    templateUrl: './product-favorite-icon.component.html',
    standalone: false
})
export class ProductFavoriteIconMHComponent extends ProductFavoriteIconComponent {
  public requestFavoriteRemove() {

    this.confirmDialogService.confirmDialogShow(
      () => { },
      $localize`:@@ProductFavoriteRemoveConfirmationTitle:Are you sure?`,
      $localize`:@@ProductFavoriteRemoveConfirmationMessage:Delete this product permanently from your \"My Shop\" list?`,
      () => {
        this.favoriteRemove(EFavoriteType.Company);
      },
    );
  }

}
